/* Print My Pet – variant picker, price / availability / media sync, POD variant UID, sticky ATC, style preselect */
(() => {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const T = (window.PMP && window.PMP.strings) || {};
  const money = (cents) => (window.PMP && typeof window.PMP.money === 'function') ? window.PMP.money(cents) : (cents / 100).toFixed(2).replace('.', ',') + ' €';

  $$('form[data-product-form]').forEach(form => {
    // The variants JSON may live inside the product wrapper or anywhere else on the page – look in both places.
    const scope = form.closest('[data-product]');
    const dataEl = (scope && $('[data-variants-json]', scope)) || $('[data-variants-json]');
    if (!dataEl) return;
    let variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { console.warn('PMP: variants JSON invalid', e); return; }
    if (!variants.length) return;

    const idInput = $('input[name="id"]', form), btn = $('[data-add-to-cart]', form), btnLabel = btn ? btn.querySelector('.btn__label') : null;
    const priceEl = $('[data-price-current]'), compareEl = $('[data-price-compare]');
    const podUid = $('[data-pod-variant-uid]', form);
    const sticky = $('[data-sticky-atc]');
    const groups = () => $$('[data-option-index]', form);
    // "Spezialwunsch": free-text field that only exists while that variant is selected.
    // Hidden alone is not enough – a disabled field is what keeps the empty property
    // out of the cart for the seven normal styles.
    const special = $('[data-special-request]', form);
    const specialInput = special && $('[data-special-request-input]', special);
    const dynamicCheckout = $('[data-dynamic-checkout]', form);
    const syncSpecial = (v) => {
      if (!special || !specialInput) return;
      const trigger = special.dataset.trigger || '';
      const on = !!(v && Array.isArray(v.options) && v.options.indexOf(trigger) > -1);
      special.hidden = !on;
      specialInput.disabled = !on;
      // Express-Checkout überspringt den Warenkorb und damit die Pflichtprüfung.
      if (dynamicCheckout) dynamicCheckout.hidden = on;
    };
    const checkedInput = (g) => g.querySelector('input:checked') || g.querySelector('select');
    const selected = () => groups().map(g => { const i = checkedInput(g); return i ? i.value : undefined; });
    const labelFor = (input) => (input && (input.dataset.label || input.value)) || '';

    const update = (fromInit) => {
      const gs = groups();
      const opts = selected();
      // Produkte ohne echte Variantenoptionen ("Default Title") rendern keinen
      // Varianten-Picker, siehe main-product.liquid: {% unless product.has_only_default_variant %}.
      // Ohne Optionsgruppen gibt es nichts zu matchen. Dann gilt die im Formular
      // gesetzte Variante, ersatzweise die einzige. Ohne diesen Zweig verglich
      // .every() gegen undefined, fand nichts und sperrte den Kaufbutton.
      let v;
      if (!gs.length) {
        const cur = idInput ? Number(idInput.value) : 0;
        v = variants.find(x => x.id === cur) || variants[0];
      } else {
        v = variants.find(x => x.options.every((o, i) => o === opts[i]));
      }
      // availability per option button (only options up to the current group are compared)
      groups().forEach((g, gi) => $$('.variant-option', g).forEach(o => {
        const inp = o.querySelector('input'); if (!inp) return;
        const test = opts.slice(); test[gi] = inp.value;
        const exists = variants.some(x => x.available && x.options.every((op, i) => i > gi ? true : op === test[i]));
        o.classList.toggle('is-unavailable', !exists);
      }));
      groups().forEach(g => { const lbl = $('[data-selected-value]', g); if (lbl) lbl.textContent = labelFor(checkedInput(g)); });
      if (!v) { syncSpecial(null); if (btn) { btn.disabled = true; if (btnLabel) btnLabel.textContent = T.unavailable || 'Nicht verfügbar'; } return; }
      syncSpecial(v);
      if (idInput) idInput.value = v.id;
      if (btn) { btn.disabled = !v.available; if (btnLabel) btnLabel.textContent = v.available ? (T.addToCart || 'In den Warenkorb') : (T.soldOut || 'Ausverkauft'); }
      if (priceEl) priceEl.textContent = money(window.PMP_BEDDING_SET ? window.PMP_BEDDING_SET.cover.price + window.PMP_BEDDING_SET.pillow.price : v.price);
      if (compareEl) { if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.hidden = false; compareEl.textContent = money(v.compare_at_price); } else compareEl.hidden = true; }
      if (podUid) podUid.value = v.pod_uid || '';
      if (!window.PMP_BEDDING_SET && v.featured_media && v.featured_media.id) { const th = $(`[data-gallery-thumb][data-media-id="${v.featured_media.id}"]`); if (th) th.click(); }
      if (sticky) { const sp = $('[data-sticky-price]', sticky); if (sp) sp.textContent = money(v.price); }
      if (!fromInit || location.search.indexOf('variant=') > -1) {
        const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      }
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
    };
    // PMP 01.10.2026: ohne ?variant= die Startvariante aus snippets/pmp-vorauswahl übernehmen (z. B. Größe M statt 2XL).
    const pmpVor = Number(window.PMP_VORAUSWAHL || 0);
    if (pmpVor && String(window.PMP_START_SUCHE || '').indexOf('variant=') < 0) {
      const want = variants.find(x => x.id === pmpVor);
      if (want) groups().forEach((g, gi) => { const inp = $$('input', g).find(i => i.value === want.options[gi]); if (inp) inp.checked = true; else { const sel = $('select', g); if (sel) sel.value = want.options[gi]; } });
    }
    form.addEventListener('change', (e) => { if (e.target.closest('[data-option-index]')) update(false); });
    update(true);
  });

  /* Style preselect via ?stil=<handle> (links from the style tiles on the homepage) */
  try {
    const want = new URL(location.href).searchParams.get('stil');
    if (want) {
      const chip = $(`[data-style-picker] .style-chip[data-style="${want.toLowerCase()}"]`);
      const input = chip && chip.querySelector('input');
      if (input && !input.checked) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
    }
  } catch (e) { /* ignore */ }
})();

// Integrationsvorschlag für product-form.js; noch nicht veröffentlicht.
// Nur native Produktformulare. cart.js verwaltet Warenkorbzeilen separat.
(() => {
  'use strict';
  const bindQuantity = form => {
    if (form.dataset.pmpQuantityBound) return;
    form.dataset.pmpQuantityBound = '1';
    form.addEventListener('click', event => {
      const button = event.target.closest('[data-qty-minus], [data-qty-plus]');
      if (!button || !form.contains(button) || button.disabled) return;
      const group = button.closest('[data-qty]');
      const input = group && group.querySelector('input[name="quantity"][data-qty-input]');
      if (!input || input.disabled || input.readOnly || input.type !== 'number') return;
      event.preventDefault();
      const minimum = input.min === '' ? 1 : Number(input.min);
      const previous = input.value;
      if (!Number.isFinite(input.valueAsNumber)) input.value = String(minimum);
      try {
        if (button.hasAttribute('data-qty-plus')) input.stepUp();
        else input.stepDown();
      } catch {
        // step="any" benötigt einen expliziten fachlichen Schritt, nicht raten.
        return;
      }
      if (input.valueAsNumber < minimum) input.value = String(minimum);
      if (input.value === previous) return;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };
  const bindWithin = root => {
    root.querySelectorAll('form[data-product-form]').forEach(bindQuantity);
  };
  bindWithin(document);
  document.addEventListener('shopify:section:load', event => bindWithin(event.target));
})();
